





import { defineComponent } from '@vue/composition-api';

const Statistics = defineComponent({
  // setup() {},
});

export default Statistics;
